import exchange from './exchange';
import sell from './sell';
import transfer from './transfer';
import withdraw from './withdraw';

export default {
  bean: 'Bean',
  coffee: 'Kahve',
  pearl: 'Pearl',
  gem: 'Gem',
  coin: 'Coin',
  coins: 'Coins',
  send: {
    details: 'Detaylar',
  },
  exchange,
  transfer,
  withdraw,
  sell,
};
